import { nsEnvelope } from '@/app/i18n/namespaces';

const ENVELOPE_STATUS = {
    SCHEDULED: { name: 'SCHEDULED', entity: 'status.SCHEDULED', namespace: nsEnvelope, variant: 'orange' },
    SENT: { name: 'SENT', entity: 'status.SENT', namespace: nsEnvelope, variant: 'green' },
    ERROR: { name: 'ERROR', entity: 'status.ERROR', namespace: nsEnvelope, variant: 'red' }
};

export default ENVELOPE_STATUS;